export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_CLIENT_DETAILS_SUCCESS = "LOAD_CLIENT_DETAILS_SUCCESS";